// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

interface Props {
  teamId: string;
  value: string;
  onChange: (value: string) => void;
}

export default function PositionSelect({ teamId, value, onChange }: Props) {
  const { data: positions = [] } = useQuery({
    queryKey: ['rle-positions', teamId],
    enabled: !!teamId,
    queryFn: async () => {
      const { data, error } = await invokeEdgeFunction('rle-list-positions', {
        body: { team_id: teamId },
      });
      if (error) throw new Error(error.message);
      if (data?.ok === false) throw new Error(data?.error?.message || 'Failed to load positions');
      return (data?.data ?? data)?.positions ?? [];
    },
  });

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger><SelectValue placeholder="Select position" /></SelectTrigger>
      <SelectContent>
        {positions.map((p: any) => (
          <SelectItem key={p.id ?? p.abbreviation} value={p.abbreviation}>
            {p.name} ({p.abbreviation})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
